/* eslint-disable @angular-eslint/template/mouse-events-have-key-events */
import { Component, HostListener, inject, OnInit } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { AuthService } from "./core/auth/auth.service";
import { CommonModule } from "@angular/common";
import { TranslateService } from "@ngx-translate/core";
import { RA_CONFIG } from "./shared/ra.config";
import { Store } from "@ngrx/store";
import { AdministrationActions } from "./store/administration/administration.actions";
import { map } from "rxjs";
import { ToastModule } from 'primeng/toast';
import { SharedModule } from "primeng/api";
import { NavbarComponent } from "./shared/components/navbar.component";
import { UIMenuItem } from "./shared/components/panel-menu.component";
import { CampaignActions } from "./store/data-monitoring/data-monitoring.actions";
import { MessagesModule } from 'primeng/messages';
import { version } from '../../package.json'
import { UsersActions, selectRoles, selectRoleLabel, selectRolesAuditSelf, selectRolesPlannerTool } from "./store/users/users.feature";
import { DialogModule } from "primeng/dialog";
import { selectTmpCampaign } from "./store/data-monitoring/data-monitoring.reducer";
import { SELF_DISABLED, INCIDENT_LINK } from "./shared/module.constants";
import { selectModulePermissions, selectPermissionsFailed } from "./store/module-permissions/module-permissions.selectors";
import { ModuleKey } from "./shared/models/module-permissions.model";
import { NoRoleAccessComponent } from "./features/no-role-access/no-role-access.component";
@Component({
  selector: "wat-root",
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    RouterOutlet,
    NavbarComponent,
    ToastModule,
    MessagesModule,
    DialogModule,
    NoRoleAccessComponent

  ],
  template: `
  @if (permissionsFailed()) {
    <wat-no-role-access></wat-no-role-access>
  } @else if(role() !== '' && role()){

    <div class="flex-nav">

      <svg
        class="waves absolute-custom"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28"
        preserveAspectRatio="none"
        shape-rendering="auto"
      >
        <defs>
          <path
            id="gentle-wave"
            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
          />
        </defs>
        <g class="parallax">
          <use
            xlink:href="#gentle-wave"
            x="48"
            y="0"
            fill="var(--wave-color)"
          />
          <use
            xlink:href="#gentle-wave"
            x="48"
            y="0"
            fill="var(--wave-color)"
          />
          <use
            xlink:href="#gentle-wave"
            x="48"
            y="3"
            fill="rgba(255,255,255,0.2)"
          />
          <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff0" />
        </g>
      </svg>
        <!-- <img src="assets/images/Athena_logo/LOGO_Athena_RED.svg" style="opacity: calc(0.1);z-index: -10; "  class="absolute  " alt="logo_gen_athena" height="800px"> -->
      
      <!-- <div aria-disabled="true" role="button" (mouseover)="visible = true;" (mouseout)="visible = false;" ngClass="absolute bottom-0 min-w-3rem w-5rem white-space-nowrap flex flex-column h-2rem left-50 z-5">
        <p [class]="visible ? 'text-white text-xs' : 'hidden '">FE VERSION : {{versionStr}}</p>
        <p [class]="visible ? 'text-white text-xs' : 'hidden '">BE VERSION : {{versionStr}}</p>
      </div> -->
      <ui-ng-navbar  
        style=" z-index: 98 !important;"
      [logo]="logo" [ngClass]="'pr-2'" [role]="getCurrentRole()" [showBreadCrumb]="true" [menu_items]="itemsToShow" [username]="(name | async)!" [incidentLink]="incidentLink" (onSignOut)="logout()"></ui-ng-navbar>
   
      <div class=" w-full px-2 pt-6 flex-container pb-2 overflow-auto  ">
        @if (!isIframe) {
        <router-outlet> </router-outlet>
      }
      
      <!-- <button 
        pButton 
        type="button" 
        icon="pi pi-info-circle" 
        class="info-btn p-button-rounded p-button-info"
        (click)="showDialog()">
      </button> -->
      </div>


      <p-toast   styleClass="custom-position flex flex-column gap-2 "/>
    </div>
  }
  `,
  styles: `
  .info-btn {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 1000;
}

.custom-position{
  z-index: 9999!important;
}
::ng-deep ui-ng-breadcrumb{
  padding-right: 28px;
  z-index: 99999!important;
}

/**  ::ng-deep .p-tooltip-arrow{
 background: red !important;
 color: green !important;
 box-shadow: none !important;
} */


.flex-nav{
      display:flex;
      flex: 1 7 auto !important;
      min-height: 100svh;
    }
  .flex-container{
        flex: 1 3 auto !important;
        align-items:stretch;
  }



.waves {
  position:fixed;
  width: 100%;
  height:35vh;
  min-height:100px;
  z-index:-1;
  bottom:0px;
}

.content {
  position:relative;
  height:50vh;
  text-align:center;
  background-color: white;
}

/* Animation */

.parallax > use {
  animation: move-forever 75s cubic-bezier(.55,.5,.45,.5)     infinite;
}
.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: 50s;
}
.parallax > use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: 54s;
}
.parallax > use:nth-child(3) {
  animation-delay: -4s;
  animation-duration: 61s;
}
.parallax > use:nth-child(4) {
  animation-delay: -5s;
  animation-duration: 67s;
}
@keyframes move-forever {
  0% {
   transform: translate3d(-90px,0,0);
  }
  100% { 
    transform: translate3d(85px,0,0);
  }
}
/*Shrinking for mobile*/
@media (max-width: 1000px) {
  .waves {
    height:40px;
    min-height:140px;
    bottom:0px;
    /**  display:none; */
  }
  .content {
    height:100vh;
  }
  h1 {
    font-size:24px;
  }
}
  
  .flex-parent{
    min-height: 100svh;
    display: flex;
  }
  .content-wrap {
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
      z-index: -2;
      overflow: hidden;
      height: 100vh; 
   
    }

    .content-wrap svg {
      width: 100%;
      height: 100vh;
    }
    ui-ng-navbar .menu-item-icon {
  width: 24px;
  height: 24px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Hide menu items without permissions */
::ng-deep .module-hidden {
  display: none !important;
}

`
})
export class AppComponent implements OnInit {
  visible = false;
  versionStr = version

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: Event) {
    this.store.dispatch(AdministrationActions.refresh());
  }


  items: UIMenuItem[] | undefined = [


    {
      label: "Audit Risk Assessment",
      content:
        "Input of risk evaluations and selection of consolidation features",
      // icon: "fa-solid  fa-gauge-high ",
      icon_color: "#f4f4f4",
      router_link: "risk-assessments",
      tooltip: 'Audit Risk Assessment',
      icon_image: 'icona_risk_assestment.svg',
      items: [],
    },
    {
      label: "Consolidation Scenario",
      content: "Calculation parameters relevant for the process",
      // icon: "fa-solid  fa-network-wired",
      icon_classes: "pi-rotate-270 pointer-events-none",
      icon_color: "#f4f4f4",
      icon_image: "consolidation_scenario_icon.svg",
      router_link: "scenario/consolidation-result",
      tooltip: 'Consolidation Scenario',
      disabled: false,
      items: [],
    },

    {
      label: "Audit Planning",
      content: "Definition of the proposed Audit Plan for subsequent years",
      // icon: "fa-solid  fa-file-invoice",
      icon_color: "#f4f4f4",
      icon_classes: " pointer-events-none",
      icon_image: "icon-planning.svg",
      router_link: "audit-planning",
      tooltip: 'Audit Planning',
      items: [],
      disabled: false
    },
    {
      label: "ICS Evaluation & Attestation",
      content: "Tracking of ICS evaluation and attestation processes",
      // icon: "fa-solid  fa-gavel",
      icon_image: 'icona_ics_and_attestation.svg',
      icon_classes: "pi-rotate-270 ",
      icon_color: "#f4f4f4",
      router_link: "ics",
      tooltip: 'ICS Evaluation & Attestation',
      items: [],
    },
    {
      label: "Audit Self Assessment",
      content: "Tracking of ICS evaluation and attestation processes",
      // icon: "fa-solid  fa-gavel",
      icon_image: 'self_ass_icon.svg',
      icon_classes: "pi-rotate-270",
      icon_color: "#f4f4f4",
      router_link: "audit-self-assessment",
      tooltip: 'Audit Self Assessment',
      items: [],
    },
    {
      label: "Planner Tool",
      content: "Planner tool",
      icon: 'fa-regular fa-calendar-check ',
      // icon_image: 'icona_ics_and_attestation.svg',
      icon_classes: "pi-rotate-270",
      icon_color: "#f4f4f4",
      router_link: "planner",
      tooltip: 'Planner Tool',
      items: [],
    },
  ];
  itemsAdmin: UIMenuItem[] | undefined =

    [
      {
        label: "Administration",
        content: "Management of transversal information and data",
        // icon: "fa-solid fa-database",
        icon_image: 'icona_administration.svg',
        icon_classes: "pi-rotate-270",
        icon_color: "#f4f4f4",
        tooltip: 'Administration',
        router_link: 'administration',
        items: [
          {
            label: "Users Profile",
            routerLink: "administration/users-profile"
          },
          {
            label: "Legal Entities",
            routerLink: "administration/legal-entities"
          },
          {
            label: "Common Process Tree",
            routerLink: "administration/common-process-tree"
          },
          {
            label: "Risk Catalogue",
            routerLink: "administration/risk-catalogue"
          },
          {
            label: "Qualitative Questionnaire",
            routerLink: "administration/qualitative-questionnaire"
          },
          {
            label: "­Standard RiskMap & Auditable Universe",
            routerLink: "administration/riskmap-auditable"
          },
          {
            label: "Threshold Control Panel",
            routerLink: "administration/threshold-control-panel",
          },
        ],
      },

      {
        label: "Audit Risk Assessment",
        content:
          "Input of risk evaluations and selection of consolidation features",
        // icon: "fa-solid  fa-gauge-high ",
        icon_color: "#f4f4f4",
        router_link: "risk-assessments",
        tooltip: 'Audit Risk Assessment',
        icon_image: 'icona_risk_assestment.svg',
        items: [],
      },
      {
        label: "Consolidation Scenario",
        content: "Calculation parameters relevant for the process",
        // icon: "fa-solid  fa-network-wired",
        icon_classes: "pi-rotate-270  pointer-events-none",
        icon_color: "#f4f4f4",
        icon_image: "consolidation_scenario_icon.svg",
        router_link: "scenario/consolidation-result",
        tooltip: 'Consolidation Scenario',
        items: [],
        disabled: false
      },
      {
        label: "Audit Planning",
        content: "Definition of the proposed Audit Plan for subsequent years",
        // icon: "fa-solid  fa-file-invoice",
        icon_color: "#f4f4f4",
        icon_image: "icon-planning.svg",
        router_link: "audit-planning",
        tooltip: 'Audit Planning',
        items: [],
        disabled: false
      },
      {
        label: "ICS Evaluation & Attestation",
        content: "Tracking of ICS evaluation and attestation processes",
        // icon: "fa-solid  fa-gavel",
        icon_image: 'icona_ics_and_attestation.svg',
        icon_classes: "pi-rotate-270",
        icon_color: "#f4f4f4",
        router_link: "ics",
        tooltip: 'ICS Evaluation & Attestation',
        items: [],
      },
      {
        label: "Audit Self Assessment",
        content: "Tracking of ICS evaluation and attestation processes",
        // icon: "fa-solid  fa-gavel",
        icon_image: 'self_ass_icon.svg',
        icon_classes: "pi-rotate-270",
        icon_color: "#f4f4f4",
        router_link: "audit-self-assessment",
        tooltip: 'Audit Self Assessment',
        items: [],
      },
      {
        label: "Planner Tool",
        content: "Planner tool",
        // icon: "fa-solid  fa-gavel",
        icon_image: 'icona_ics_and_attestation.svg',
        icon_classes: "pi-rotate-270",
        icon_color: "#f4f4f4",
        router_link: "planner",
        tooltip: 'Planner Tool',
        items: [],
      },
    ];
  title = "Genarali Athena";
  logo = RA_CONFIG.logo;
  incidentLink = INCIDENT_LINK;
  isIframe = false;
  loginDisplay = false;
  authService: AuthService = inject(AuthService);
  username = this.authService.user.pipe(map(user => user.username ?? ''))
  name = this.authService.user.pipe(map(user => user.name ?? ''))
  translateService: TranslateService = inject(TranslateService);
  store: Store = inject(Store);
  role = this.store.selectSignal(selectRoles);
  roleLabel = this.store.selectSignal(selectRoleLabel);
  roleAuditSelf = this.store.selectSignal(selectRolesAuditSelf);
  rolesPlannerTool = this.store.selectSignal<string>(selectRolesPlannerTool);
  permissions = this.store.selectSignal(selectModulePermissions);
  permissionsFailed = this.store.selectSignal(selectPermissionsFailed);
  itemsToShow: UIMenuItem[] | undefined;
  displayDialog = false;
  tmpCampagin = this.store.selectSignal(selectTmpCampaign)
  router: Router = inject(Router);

  // Mapping router_link to ModuleKey
  private readonly routerLinkToModuleKey: Record<string, ModuleKey> = {
    'administration': 'administration',
    'risk-assessments': 'risk-assessments',
    'scenario/consolidation-result': 'scenario',
    'audit-planning': 'audit-planning',
    'ics': 'ics-campaign',
    'audit-self-assessment': 'audit-self-assessment',
    'planner': 'planner',
  };


  ngOnInit(): void {

    this.loginDisplay = this.authService?.loginDisplay || false;
    this.isIframe = this.authService?.isIframe || false;
    this.translateService.setDefaultLang("en");
    this.translateService.use("en");
    this.store.dispatch(UsersActions.setRoles());
    this.store.dispatch(UsersActions.setRolesAuditSelf());
    this.store.dispatch(UsersActions.setRolesPlannerTool());
    // Module permissions are now loaded via APP_INITIALIZER (see app.config.ts)
    // this ensures they're ready before any route guards execute

    // Select items based on role and add hidden class based on permissions
    const baseItems = this.role() === 'ROLE_CENTRAL_SUPER-USER' ? this.itemsAdmin : this.items;
    this.itemsToShow = baseItems?.map(item => ({
      ...item,
      styleClass: (item.styleClass || '') + (this.isItemHidden(item) ? ' module-hidden' : '')
    }));

    this.store.dispatch(AdministrationActions.refresh());
    // if (!this.tmpCampagin().year) {
    //   this.store.dispatch(CampaignActions.loadLastCampaign({}));
    // }

  }
  showDialog() {
    this.displayDialog = true;
  }

  loginRedirect() {
    this.authService?.loginRedirect();
  }

  logout() {
    this.authService?.logout();
  }
  loginPopup() {
    this.authService?.loginPopup();
  }

  getMenuItems(): UIMenuItem[] | undefined {
    if (this.role() === 'ROLE_CENTRAL_SUPER-USER') {
      return this.itemsAdmin;
    }
    return this.items;
  }

  getCurrentRole(): string {
    const currentUrl = this.router.url;
    if (currentUrl.includes('audit-self-assessment')) {
      return this.roleAuditSelf();
    }
    if (currentUrl.includes('planner')) {
      return this.rolesPlannerTool();
    }
    return this.roleLabel();
  }

  /**
   * Checks if a menu item should be hidden based on permissions
   */
  isItemHidden(item: UIMenuItem): boolean {
    const perms = this.permissions();
    if (!item.router_link) return false;
    if (!perms) return true;

    const moduleKey = this.routerLinkToModuleKey[item.router_link];
    if (!moduleKey) return false;

    return perms[moduleKey] !== true;
  }
}
